export const numberToFixed = (num) => {
    if (num) {
        return Number.isInteger(num) ? num.toString() : num.toFixed(2);
    }
    return "--";
}